import { FC } from 'react';
import { useClassName } from '../../hooks/use-class-name';
import SpriteIcon from '../shared/sprite-icon';
import { useTranslation } from '../../hooks/use-translation';
import Image from 'next/image';

// -----------------------------------------------------------
interface Props {
  isOpen: boolean;
  appName: string;
  onClickClose: () => void;
  onClickUninstall: () => void;
}

// -----------------------------------------------------------
export const UninstallModal: FC<Props> = ({
  isOpen,
  appName,
  onClickClose,
  onClickUninstall,
}): JSX.Element => {
  const { t } = useTranslation();
  const className = useClassName(
    {
      'modal-is-open': isOpen,
    },
    'uninstall-modal',
  );

  return (
    <div className={className}>
      <div className="uninstall-modal-main">
        <button
          className="clean-icon-btn close-modal"
          onClick={onClickClose}
        >
          <SpriteIcon icon="closeSmall" />
        </button>

        <div className="uninstall-modal-content">
          <div>
            <Image
              src="/static_next/img/uninstall.webp"
              alt="Uninstall"
              width={100}
              height={100}
              className="uninstall-img"
            />
            <h2>{t('uninstallTitle')}</h2>
            <p>
              {t('uninstallDescription', {
                appName,
              })}
            </p>
          </div>

          <div className="uninstall-actions">
            <button
              className="btn-secondary small cancel-btn"
              onClick={onClickClose}
            >
              {t('cancel')}
            </button>
            <button
              className="btn-secondary small"
              onClick={onClickUninstall}
            >
              {t('uninstall')}
            </button>
          </div>
        </div>
      </div>
      <div className="bg" onClick={onClickClose} />
    </div>
  );
};
